import { createAction, props, union } from '@ngrx/store';

export const error = createAction('[Shared / Auth Call] Error', props<Record<string, unknown>>());
export const reset = createAction('[Shared / Auth Call] Reset', props<Record<string, unknown>>());
export const load = createAction('[Shared / Auth Call] Reset', props<Record<string, unknown>>());
export const received = createAction('[Shared / Auth Call] Received', props<Record<string, unknown>>());

const all = union({
  error,
  load,
  received,
  reset,
});
export type Actions = typeof all;
